function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.299 12.177a.249.249 0 01-.073-.177c0-.067.026-.13.073-.177l9.262-9.262A1.5 1.5 0 1021.437.44l-9.26 9.258a.253.253 0 01-.355 0L2.561.44A1.5 1.5 0 10.44 2.561l9.26 9.262a.252.252 0 01-.001.354L.44 21.439a1.501 1.501 0 00.673 2.51 1.5 1.5 0 001.449-.389l9.261-9.262a.25.25 0 01.354 0l9.261 9.262a1.5 1.5 0 102.122-2.12l-9.26-9.263z"
});

function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgCloseIcon;